<template>
  <b-card
    :class="{ 'border-primary': skin === 'dark', 'border-secondary border-lighten-5': skin === 'light' }"
  >
    <b-row>
      <b-col
        lg="2"
        md="12"
        sm="12"
        class="ml-3"
      >
        <b-avatar
          :text="avatarText(persona.nombreCompleto)"
          :variant="`light-${resolveUserrolVariant(persona.rol)}`"
          size="64px"
          rounded
          class="mb-1"
        />
      </b-col>
      <b-col
        lg="8"
        md="12"
        sm="12"
        class="mb-1"
      >
        <h4>
          {{ userData.nombreCompleto }}
        </h4>
        <p class="card-text">
          {{ persona.email }}
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!--Boton para editar el perfil-->
        <boton-editar
          v-if="this.$route.path !=='/perfil'"
          :persona-fk="userData.fk"
          class="mb-3"
        />
        <boton-mi-perfil-editar
          v-if="this.$route.path ==='/perfil' && userRol.id !== 1"
          class="mb-3"
        />
        <div
          v-if="userRol.id === 1"
        >
          <p
            class="mx-3"
          >Si necesitas cualquier corrección de datos personales, por favor contacta a Control Escolar: Correo: especialidades@indetec.gob.mx Teléfono 3336695550 al 59 Extensión 960 y 310</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <hr class="mb-2">
        <p class="mt-2 ml-2">
          <b>Datos personales</b>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        lg="6"
        md="6"
        sm="12"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex flex-column ml-2">
          <div class="mb-3">
            <p class="card-text">
              Nombre :
              <b> {{ persona.nombre }}  </b>
            </p>
            <p
              v-if="persona.segundoNombre!=null && persona.segundoNombre!=''"
              class="card-text"
            >
              Segundo nombre :
              <b> {{ persona.segundoNombre }}  </b>
            </p>
            <p class="card-text">
              Apellido paterno:
              <b> {{ persona.apellidoPaterno }}  </b>
            </p>
            <p
              v-if="persona.apellidoMaterno!=null && persona.apellidoMaterno!=''"
              class="card-text"
            >
              Apellido materno:
              <b> {{ persona.apellidoMaterno }}  </b>
            </p>
            <p class="card-text">
              Nacionalidad: <b> {{ persona.nacionalidad }}  </b>
            </p>
          </div>
        </div>
      </b-col>
      <b-col
        lg="6"
        md="6"
        sm="12"
        class="mb-1 ml-2 mx-md-0"
      >
        <p class="card-text">
          Nacimiento [año-mes-dia]: <b>{{ persona.fechaNacimiento }} </b>
        </p>
        <p class="card-text">
          RFC personal : <b>{{ persona.rfc }}</b>
        </p>
      </b-col>
    </b-row>
    <b-row class="ml-1 mb-3">
      <b-col
        lg="2"
        md="2"
        sm="2"
      >
        <b-avatar
          variant="light-primary"
          rounded
        >
          <feather-icon
            icon="FileTextIcon"
            size="18"
          />
        </b-avatar>
      </b-col>
      <b-col
        lg="8"
        md="8"
        sm="8"
      >
        <h5 class="mb-0">
          {{ persona.curp }}
        </h5>
        <small>CURP</small>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <hr class="mb-2">
        <p class="mt-2 ml-2">
          <b>Datos dirección personal</b>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <div class="d-flex flex-column">
          <p class="card-text">
            <detalle-usuario-direccion :user-data="userData" />
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <hr class="mb-2">
        <p class="mt-2 ml-2">
          <b>Datos de contacto</b>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex flex-column ml-2">
          <div class="mb-3">
            <p class="card-text">
              <feather-icon
                icon="SmartphoneIcon"
                class="mr-75"
              />
              Teléfono personal :
              <b> {{ persona.telefono1 }} </b>
            </p>
            <p class="card-text">
              <feather-icon
                icon="PhoneIcon"
                class="mr-75"
              />
              Teléfono de trabajo :
              <b> {{ persona.telefono2 }}  ext: {{ persona.extension }} </b>
            </p>
          </div>
        </div>
      </b-col>
      <b-col
        lg="12"
        md="12"
        sm="12"
        class="mb-1"
      ><div class="d-flex flex-column ml-2">
        <div class="mb-3">
          <p class="card-text">
            <feather-icon
              icon="MailIcon"
              class="mr-75"
            />
            Correo electrónico personal :
            <b> {{ persona.email }}  </b>
          </p>
          <p class="card-text">
            <feather-icon
              icon="MailIcon"
              class="mr-75"
            />
            Correo electrónico institucional :
            <b> {{ persona.emailAlt }} </b>
          </p>
        </div>
      </div>
      </b-col>
    </b-row>
    <b-row class="ml-1 mb-3">
      <b-col>
        <hr class="mb-2">
        <p><b>Profesión</b></p>
        <div
          v-for="(item, index) in profesion"
          :key="index"
          class="d-flex align-items-center"
        >
          <b-avatar
            variant="light-primary"
            rounded
          >
            <feather-icon
              icon="PenToolIcon"
              size="18"
            />
          </b-avatar>
          <div class="ml-1">
            <h5 class="mb-0">
              {{ item.acronimo }}
              {{ item.carrera }}
            </h5>
            <h5 class="mb-0">
              <small>Cargo:</small>
              {{ item.puesto }}
            </h5>
            <h5 class="mb-0">
              <small>Adscripción específica: </small>
              {{ item.departamento }}
            </h5>
            <h5 class="mb-0">
              <small>Cédula: </small>
              {{ item.cedula }}
            </h5>
            <h5 class="mb-0">
              <small>Institución educativa donde se obtuvo título/cédula: </small>
              {{ item.institucion_educativa }}
            </h5>
            <h5
              v-if="estadoOptions.length !== 0 && item.ef_titulacion"
              class="mb-0"
            >
              <small>Entidad Federativa de titulación: </small>
              {{ estadoOptions.find(edo => edo.id === item.ef_titulacion).nombre }}

            </h5>
            <h5 class="mb-0">
              <small>Clave de Centro de Trabajo: </small>
              {{ item.cct }}
            </h5>
            <h5
              class="mb-0"
            >
              <small>Fecha de expedición de la cédula [YYYY-MM-DD]: </small>
              <span v-if="item.fecha_para_autoridad_educativa">
                {{ item.fecha_para_autoridad_educativa }}
              </span>
            </h5>
            <h5 v-if="item.tipo_gobierno">
              <small>Tipo de Gobierno: </small>
              {{ item.tipo_gobierno.nombre }}
            </h5>
            <h5 v-if="item.entidad_federativa">
              <small>Entidad Federtiva: </small>
              {{ item.entidad_federativa.nombre }}
            </h5>
            <h5 v-if="item.municipio">
              <small>Municipio: </small>
              {{ item.municipio.nombre }}
            </h5>
            <h5 v-if="item.dependencia && item.tipo_gobierno.id !== 3">
              <small>Dependencia: </small>
              {{ item.dependencias.nombre }}
            </h5>
          </div>
        </div>
        <hr class="mt-2">
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BAvatar, BRow, BCol,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import {
  configTableUsuarios, useUsuariosCatalogos,
} from '@/views/campus/usuarios/useUsuarios'
import store from '@/store'
import { computed } from '@vue/composition-api'
import DetalleUsuarioDireccion from '@/views/campus/usuarios/components/detalle-usuario/DetalleUsuarioDireccion.vue'
import moment from 'moment'
import botonEditar from './components/botonEditarCualquierPerfil.vue'
import botonMiPerfilEditar from './components/botonEditarMiPerfil.vue'

export default {
  components: {
    BCard, BRow, BCol, BAvatar, botonEditar, botonMiPerfilEditar, DetalleUsuarioDireccion,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // FORMS
      persona: this.userData.persona[0],
      profesion: this.userData.profesion,
    }
  },
  setup() {
    const userRol = computed(() => store.state.cuenta.rolSelected) //* Return current role
    const skin = computed({
      get: () => store.state.appConfig.layout.skin,
    })
    const { resolveUserrolVariant } = configTableUsuarios()
    const {
      estadoOptions,
    } = useUsuariosCatalogos()

    return {
      skin,
      estadoOptions,
      avatarText,
      resolveUserrolVariant,
      userRol,
      moment,
    }
  },
}
</script>
